import { SVGProps } from 'react'

export const CloseIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="20rem"
      height="20rem"
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <line x1="3.8809" y1="4.11182" x2="15.9017" y2="16.1326" stroke="white" />
      <line
        x1="15.9016"
        y1="3.89434"
        x2="3.88083"
        y2="15.9152"
        stroke="white"
      />
    </svg>
  )
}
